import { Register } from '@features/TimberBuyer/Register'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/timberbuyer/register')({
  component: Register,
  staticData: {
    breadcrumb: 'Registrer tømmerkjøper',
  },
})
